export const MeetingContext = {
    PROCEDURE: 'procedures',
    CANDIDATE: 'candidates',
};

export const ConfigurationMode = {
    LOGIN: 'login',
    TOTP: 'totp',
    SIGNED: 'signed',
}